import { FileText, Image, File as FileIcon, Download } from "lucide-react";

const FILE_ICONS = {
  "application/pdf": FileText,
  "text/plain": FileText,
  "text/csv": FileText,
  "application/msword": FileText,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": FileText,
  "image/png": Image,
  "image/jpeg": Image,
  "image/webp": Image,
};

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

export default function AttachmentList({ attachments = [] }) {
  if (!attachments?.length) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2" data-testid="attachment-list">
      {attachments.map((f) => {
        const Icon = FILE_ICONS[f.content_type] || FileIcon;
        return (
          <a
            key={f.file_id}
            href={`${process.env.REACT_APP_BACKEND_URL}${f.url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-spa-sage/5 hover:bg-spa-sage/10 border border-spa-border/50 rounded-lg px-3 py-1.5 text-sm transition-colors"
            data-testid={`attachment-${f.file_id}`}
          >
            <Icon className="w-4 h-4 text-spa-terracotta" />
            <span className="text-spa-text-secondary truncate max-w-[150px]">{f.original_name}</span>
            <span className="text-spa-text-secondary/50 text-xs">{formatSize(f.size)}</span>
            <Download className="w-3 h-3 text-spa-text-secondary/40" />
          </a>
        );
      })}
    </div>
  );
}
